<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="'/visits/tables/provinces'"
      [chartColumn]="'Province'"
    >
    </app-api-table>
  }
</app-tab-layout>
